<template>
  <div
    v-if="carousel"
    :class="{
      'carousel-slider-controls-fi': true,
      'carousel-slider-controls-fi--dark': dark,
    }"
  >
    <span
      :class="{
        'carousel-slider-controls-fi__arrow': true,
        'carousel-slider-controls-fi__arrow--prev': true,
        'carousel-slider-controls-fi__arrow--inactive': carousel.isPrevDisabled,
      }"
      :aria-disabled="carousel.isPrevdDisabled"
      role="button"
      @click="prevSlide"
    >
      <arrow-icon />
    </span>
    <span
      :class="{
        'carousel-slider-controls-fi__arrow': true,
        'carousel-slider-controls-fi__arrow--next': true,
        'carousel-slider-controls-fi__arrow--inactive': carousel.isNextDisabled,
      }"
      :aria-disabled="carousel.isNextDisabled"
      role="button"
      @click="nextSlide"
    >
      <arrow-icon />
    </span>
  </div>
  <div
    v-else
    class="fi-hidden"
  >
    no carousel
  </div>
</template>

<script setup lang="ts">
import { ArrowIcon } from 'atoms/index';
import type { ComponentPublicInstance } from 'vue';

import CarouselFi from './CarouselFi.vue';

const props = defineProps<{
  carousel: ComponentPublicInstance<typeof CarouselFi> | null;
  dark?: boolean;
}>();

const nextSlide = () => {
  if (props.carousel && !props.carousel.isNextDisabled) {
    props.carousel.next();
  }
};

const prevSlide = () => {
  if (props.carousel && !props.carousel.isPrevDisabled) {
    props.carousel.prev();
  }
};
</script>

<style scoped lang="scss">
@import './carousel-slider-controls-fi';
</style>
